'use es6';

import I18n from 'I18n';
import { toMoment } from 'UIComponents/core/SimpleDate';
import { Networks, FBCampaignObjective, LinkedInObjective, TrackingStatusCodes } from 'AdsUI/lib/Constants';
export const TRACKING_STATUS = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  ERROR: 'ERROR',
  LEAD_GEN: 'LEAD_GEN',
  LIMITED: 'LIMITED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  PENDING: 'PENDING',
  DISMISSED: 'DISMISSED'
};
export const isLeadGen = (campaignEntity, adGroupEntity) => campaignEntity && (campaignEntity.network === Networks.FACEBOOK && campaignEntity.type === FBCampaignObjective.LEAD_GENERATION || adGroupEntity && campaignEntity.network === Networks.LINKEDIN && adGroupEntity.objective === LinkedInObjective.LEAD_GENERATION);
export default ((adAccount, campaignEntity, adGroupEntity, adEntity, trackingStatus, timeRange) => {
  const leadGen = isLeadGen(campaignEntity, adGroupEntity);

  if (leadGen) {
    return TRACKING_STATUS.LEAD_GEN;
  }

  if (!adAccount.trackingEnabled) {
    return TRACKING_STATUS.DISABLED;
  }

  if (trackingStatus.code === TrackingStatusCodes.NOT_APPLICABLE) {
    return TRACKING_STATUS.NOT_APPLICABLE;
  }

  if (trackingStatus.statuses.size > 0 && trackingStatus.statuses.filter(status => !status.dismissedAt).size === 0) {
    return TRACKING_STATUS.DISMISSED;
  }

  if (trackingStatus.statuses.size > 0) {
    return TRACKING_STATUS.ERROR;
  }

  if (trackingStatus.code === TrackingStatusCodes.UNTRACKED) {
    return TRACKING_STATUS.PENDING;
  }

  const trackingEnabledMoment = I18n.moment(adAccount.trackingSince);
  const timeRangeBeginning = toMoment(timeRange.startDate);
  const timeRangeDays = timeRangeBeginning.diff(trackingEnabledMoment, 'days');

  if (timeRangeDays < 0) {
    return TRACKING_STATUS.LIMITED;
  }

  return TRACKING_STATUS.ACTIVE;
});